/* unplugin-vue-components disabled */import { ElLoadingDirective as __unplugin_directives_0 } from 'element-plus/es';import 'element-plus/es/components/loading/style/css';
import { ElDialog as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElEmpty as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/empty/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b78c2102"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "task-box"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "定时任务：", -1));
const _hoisted_4 = {
  style: {
    "margin-right": "8px"
  }
};
const _hoisted_5 = {
  class: "content"
};
import { apiUsdkCpsCancelCdn, apiUsdkGetTaskList } from '@/api/usdk';
export default /*#__PURE__*/_defineComponent({
  __name: 'consTaskDialog',
  emits: ['success'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const dialogVisible = ref(false);
    const taskLoading = ref(false);
    const cronTaskList = ref([]);
    const gameInfo = ref({});
    const emits = __emit;
    // 取消任务taskId
    const cancelCronTadk = item => {
      taskLoading.value = true;
      apiUsdkCpsCancelCdn({
        recordId: item.recordId
      }).then(res => {
        if (res.code === 0) {
          getCronTaskList();
          emits('success');
        }
      }).catch(() => {
        taskLoading.value = false;
      });
    };
    // 获取定时任务列表
    const getCronTaskList = () => {
      taskLoading.value = true;
      apiUsdkGetTaskList({
        gid: gameInfo.value.Id
      }).then(res => {
        if (res.code === 0) {
          cronTaskList.value = res.data;
        }
      }).finally(() => {
        taskLoading.value = false;
      });
    };
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const show = data => {
      dialogVisible.value = true;
      gameInfo.value = data;
      getCronTaskList();
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_empty = __unplugin_components_1;
      const _component_el_dialog = __unplugin_components_2;
      const _directive_loading = __unplugin_directives_0;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: "发布CDN",
        width: "600px",
        "before-close": () => handleClose()
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cronTaskList), item => {
          return _openBlock(), _createElementBlock("div", {
            class: "item",
            key: item.recordId
          }, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("span", _hoisted_4, _toDisplayString(item.cdnTime), 1), _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: $event => cancelCronTadk(item)
          }, {
            default: _withCtx(() => [_createTextVNode("取消任务")]),
            _: 2
          }, 1032, ["onClick"])]), _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1)]);
        }), 128)), !_unref(cronTaskList) || _unref(cronTaskList).length <= 0 ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 0,
          description: "暂无数据"
        })) : _createCommentVNode("", true)])), [[_directive_loading, _unref(taskLoading)]])])]),
        _: 1
      }, 8, ["modelValue", "before-close"]);
    };
  }
});